import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { GOOGLE_MAP_NON_REFERER_KEY } from '../const/map.consts';
var googleMapApi = createApi({
    reducerPath: 'mapApi',
    baseQuery: fetchBaseQuery({
        baseUrl: "https://maps.googleapis.com/maps/api/",
    }),
    endpoints: function (builder) { return ({
        geocode: builder.query({
            query: function (_a) {
                var _b = _a.address, address = _b === void 0 ? '' : _b;
                return ({
                    url: "geocode/json?address=".concat(address, "&key=").concat(GOOGLE_MAP_NON_REFERER_KEY),
                    method: "GET",
                });
            }
        })
    }); }
});
export var useGeocodeQuery = googleMapApi.useGeocodeQuery;
export default googleMapApi;
